export const ADMIN_ROUTE_PATHS = [
  "/",
  "/main/banner",
  "/main/popup",
  "/main/schedule",
  "/notice",
  "/notice/create",
  "/notice/update/:noticeId",
  "/shopManager",
  "/shopManager/shopRegister",
  "/shopManager/editItem/:shopId",
  "/communication/suggestion",
  "/communication/suggestion/:id",
  "/communication/ask",
  "/communication/ask/:id",
  "/dataCollection/votingBody",
  "/dataCollection/budget",
  "/dataCollection/bylaws",
  "/dataCollection/other",
  "/members/adminPermissions",
  "/members/adminPermissions/adminRegister",
  "/members/memberManager",
  "/setting",
  "/main/banner/register",
  "/main/banner/edit/:bannerId",
  "/main/popup/register",
  "/main/popup/edit/:popupId",
  "/dataCollection/register/:category",
  "/dataCollection/bylaws/:dataNoticeId",
  "/dataCollection/budget/:dataNoticeId",
  "/dataCollection/votingBody/:dataNoticeId",
  "/dataCollection/other/:dataNoticeId",
];
